module.exports = __webpack_public_path__ + "img/khal_img05.7780e94d.svg";